<template>
  <div class="gray-back" style="height: 100%">
    <!-- 登陆界面 -->
    <div class="login-box" v-if="numShow">
      <div class="score-login-box">
        <div class="score-login-logo">
          <!--        <img src="https://static.dierqudao.com/images/cca/login-logo.png" alt="">-->
          <img src="../../../assets/images/score/login-logo.png" alt="">
        </div>
      </div>
      <div class="score-login-extra">
        <van-cell-group class="score-cell"> 
          <van-field
              v-model="userNum"
              name="身份证号"
              :left-icon="require('../../../assets/images/score/login-card.png')"
              clearable
              :readonly="true"
              @focus="onFocus"
              placeholder="请输入身份证号"
              :rules="[{ required: true, message: '身份证号' }]"
          />
          <div class="score-button">
            <van-button round block type="info" color="linear-gradient(to right, #72CAF9, #2492FB)" @click="onSubmit"
                        v-if="!saveLoading">
              登录
            </van-button>
            <van-button round block type="info" color="linear-gradient(to right, #65F6D6, #0EB993)" v-else>
              登录中...
            </van-button>
          </div>

          <!--        <div class="check-text" @click="toCheckLogin">我是复核</div>-->
          <!--                </van-form>-->
        </van-cell-group>


      </div>
    </div>

    <!-- 打分界面 -->
    <div class="score-box" v-else>
      <div class="black-back">
        <div class="score-head">
          <div class="score-logo">
            <div class="score-logo-box">
              <!--          <img src="https://static.dierqudao.com/images/cca/login-logo.png" alt="">-->
              <img src="../../../assets/images/score/login-logo.png" alt="">
            </div>
          </div>
          <div class="score-title show-two-row">{{ apply.danwei }}</div>
          <div class="score-title-child">{{ apply.datetitle }}</div>
          <!--          <div class="score-title-child" @click="peopleShow = true">{{ exame.subject.mingcheng }}</div>-->
        </div>

        <div class="score-content">
          <div class="score-content-name flex-start" v-if="!scoreVisible">
            <div @click="changeMember(index)" :key="index" :class="index == currentMemberIndex ? 'score-name-li score-name-li-active': 'score-name-li'" v-for="(item, index) in list2[currentIndex]">
              {{item.name}}
            </div>
          </div>

          <div class="score-content-box" v-if="scoreVisible">
            <div class="score-content-top">
              <div class="score-value-box">
                <div class="score-value-text flex-between">
                  <div class="flex-start">
                    <div class="score-value-label"></div>
                    <div class="score-value-li">分值</div>
                    <div class="score-value-li" style="position: absolute;right: 0.5rem;" @click="scoreVisible=false">返回<van-icon name="revoke" /></div>
                  </div>
                </div>
                <div class="score-value-content flex-center">{{ scoreValue > 0 ? scoreValue : '--' }}</div>
                <div class="score-value-tip">{{scoreLabel}}</div>
              </div> 
            </div>
            <div class="score-content-bottom flex-start" style="margin-top:10px">
              <div class="key-left">
                <div class="key-li" @click="onKey(1)">1</div>
                <div class="key-li" @click="onKey(2)">2</div>
                <div class="key-li" @click="onKey(3)">3</div>
                <div class="key-li" @click="onKey(4)">4</div>
                <div class="key-li" @click="onKey(5)">5</div>
                <div class="key-li" @click="onKey(6)">6</div>
                <div class="key-li" @click="onKey(7)">7</div>
                <div class="key-li" @click="onKey(8)">8</div>
                <div class="key-li" @click="onKey(9)">9</div>
                <div class="key-li-full" @click="onKey(0)">0</div>
                <div class="key-li" @click="onKey('.')">.</div>
              </div>
              <div class="key-right">
                <div class="key-delete flex-center" @click="onKey('delete')">
                  <!--            <img src="https://static.dierqudao.com/images/cca/score-delete.png" alt="">-->
                  <img src="../../../assets/images/score/score-delete.png" alt="">
                </div>
                <div class="key-button flex-center" style="background: #1989FA;color: #fff;" @click="onScoreSave">提交
                </div>
                <!--              <div class="key-button flex-center" style="background: #1989FA;color: #fff;" @click="onSubmit"-->
                <!--                   v-if="row.caipan.jgroup === row.subject.jgroup && !scoreCurrent || scoreStatus">提交-->
                <!--              </div>-->
                <!--              <div class="key-button flex-center" style="background: #44D7B6;color: #fff;cursor:not-allowed " v-else>完成-->
                <!--              </div>-->
              </div>
            </div>
          </div>

          <!-- 分数概览 -->
          <div class="score-content-box" v-else>
            <div class="score-content-top">
              <div class="score-value-box">
                <div class="score-value-text flex-between">
                  <div class="flex-start">
                    <div class="score-value-label"></div>
                    <div class="score-value-li">{{memberRow.name}} （{{memberRow.grade}}星级）</div>
                  </div>
                </div>
                <div class="score-value-ul">
                  身份证 {{memberRow.num}} 
                </div>
                <div class="score-value-ul"> 
                  当前考官 {{user.name}}
                </div>

                <div class="score-value-text flex-between">
                  <div class="flex-start">
                    <div class="score-value-label"></div>
                    <div class="score-value-li">分数概览</div>
                  </div>
                </div>

                <div class="score-value-ul">
                  <div class="score-value-li flex-between"  @click="onScoreOperate('score_fanteng','转体')">
                    <div class="score-value-li-left">翻腾</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_fanteng'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div class="score-value-li flex-between" @click="onScoreOperate('score_zhuanti','转体')" >
                    <div class="score-value-li-left">转体</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_zhuanti'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div class="score-value-li flex-between"  @click="onScoreOperate('score_tiaoyue','跳跃')">
                    <div class="score-value-li-left">跳跃</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_tiaoyue'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div class="score-value-li flex-between"  @click="onScoreOperate('score_pingheng','平衡柔韧')">
                    <div class="score-value-li-left">平衡柔韧</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_pingheng'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div class="score-value-li flex-between"  @click="onScoreOperate('score_liliang','力量素质')">
                    <div class="score-value-li-left">力量素质</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_liliang'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div class="score-value-li flex-between"  @click="onScoreOperate('score_dongzuo','动作组合')">
                    <div class="score-value-li-left">动作组合</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_dongzuo'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                  <div v-show="exame.year_type==2" class="score-value-li flex-between"  @click="onScoreOperate('score_sudu','速度与灵敏')">
                    <div class="score-value-li-left">速度与灵敏</div>
                    <div class="score-value-li-right flex-start">
                      <div class="score-value-li-text">{{memberRow['score_sudu'+(userIndex)]}}</div>
                      <van-icon name="edit" />
                    </div>
                  </div>
                </div>

                <div class="score-value-text score-value-total flex-between">
                  <div class="flex-start">
                    <div class="score-value-label"></div>
                    <div class="score-value-li">总分</div>
                    <div class="score-value-li-total">{{memberRow.score_total}}</div>
                  </div>
                </div>
              </div>
              <div class="flex-between">

                <div class="score-caipan-button-box" @click="onSubjectPrev()">
                  <div class="score-caipan-button flex-center">上一组
                  </div> 
                </div>
                <div class="score-caipan-button-box" @click="onSubjectNext()">
                  <div class="score-caipan-button flex-center">下一组
                  </div> 
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-number-keyboard
        :show="keyShow"
        extra-key="X"
        close-button-text="完成"
        @close="keyShow = false"
        v-model="userNum"
    />
  </div>
</template>
<style scoped>
.score-value-ul {
  display: flex;
  flex-wrap: wrap;
  padding: .3rem .3rem 0 .3rem;
}

.score-value-li-total {
  margin-left: 1.3rem;
  font-size: .84rem;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #000000;
}

.score-value-ul .score-value-li {
  width: 46%;
  margin-right: 8%;
  margin-bottom: .2rem;
}

.score-value-ul .score-value-li:nth-child(even) {
  margin-right: 0;
}

.score-value-ul .score-value-li-left{
  font-size: .34rem;
  font-weight: 400;
  color: #333333;
}

.score-value-ul .score-value-li-text {
  font-size: .34rem;
  font-weight: 400;
  color: #666666;
}

.score-value-ul .score-value-li-right img {
  width: .28rem;
  height: .28rem;
  margin-left: .1rem;
}

.score-caipan-button-box {
  height: .9rem;
  width: 40%;
  text-align: center;
  border-radius: .9rem;
  color: #fff;
  font-weight: 500;
  font-size: .18rem;
  margin: .48rem 0 0;
  background: #1989FA;
}

.score-caipan-button {
  font-size: .28rem;
  line-height: .9rem;
}

.show-two-row {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.score-content-name {
  background: #fff;
  font-size: .2rem;
  font-weight: 500;
  color: #666666;
  /*padding: .2rem 0;*/
  height: .66rem;
  width: 100%;
  border-radius: .28rem;
  margin-bottom: .28rem;
}

.score-content-name .score-name-li {
  width: 25%;
  text-align: center;
}

.score-content-name .score-name-li-active {
  background: #1D85E2;
  box-shadow: 0px 1px 7px 0px rgba(74, 144, 226, 0.1);
  font-weight: 500;
  height: .66rem;
  border-radius: .28rem;
  line-height: .66rem;
  color: #F2F7FF;
}

@media screen and (min-width: 768px) {
  .check-text {
    text-align: center;
    padding: .2rem;
    font-size: 16px;
    cursor: pointer;
  }

  .score-login-box {
    /*background: url("https://static.dierqudao.com/images/cca/login-bg.png") no-repeat;*/
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    /*width: 7.5rem;*/
    /*height: 3.8rem;*/
    background-size: 100% 1.2rem;
    height: 1.2rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.2rem;
    height: 1.2rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.6rem;
    left: 3.15rem;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin: .8rem 0;
  }

  .score-login-extra .score-cell {
    padding: 0.5rem 0.5rem 0.8rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: .3rem;
    height: .3rem;
  }

  .score-login-extra >>> .van-field__body input {
    height: .3rem;
    font-size: .2rem;
  }

  .score-login-extra .score-button {
    padding: .2rem 0.4rem 0;
  }
}

@media screen and (max-width: 768px) {
  .check-text {
    text-align: center;
    margin-top: .2rem;
    padding: .2rem;
    font-size: 16px;
    cursor: pointer;
  }

  .score-login-box {
    background: url("../../../assets/images/score/login-bg.png") no-repeat;
    /*width: 7.5rem;*/
    /*height: 3.8rem;*/
    background-size: 100% 3.8rem;
    height: 3.8rem;
    position: relative;
  }

  .score-login-box .score-login-logo {
    width: 1.6rem;
    height: 1.6rem;
    box-shadow: 0 1px 20px 0 rgba(28, 140, 250, 0.3);
    border-radius: 10px;
    background: #fff;
    position: absolute;
    bottom: -0.8rem;
    left: 2.95rem;
  }

  .score-login-extra .score-cell {
    padding: 1rem 0.5rem;
  }

  .score-login-extra .score-button {
    padding: 2rem 0.4rem 0;
  }

  .score-login-logo img {
    width: 100%;
    height: 100%;
  }

  .score-login-extra {
    margin-top: 2rem;
  }

  .score-login-extra >>> .van-icon__image {
    width: 28px;
    height: 28px;
  }

  .score-login-extra >>> .van-field__body input {
    height: 28px;
  }

  /*  打分界面*/
  .black-back {
    background: rgb(0, 0, 0);
    min-height: 100vh;
  }

  .score-value-text {
    padding-top: 0.2rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }
  .score-value-total {
    padding-bottom: .7rem;
  }

  .score-value-label {
    width: 3px;
    height: 0.28rem;
    background: #1D85E2;
    border-radius: 5px;
    margin-right: .1rem;
  }

  .score-value-li {
    font-size: 0.35rem;
    font-weight: 500;
    color: #000000;
  }

  .score-value-content {
    font-size: 1.4rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #000000;
    margin: 0.3rem 0 .2rem;
  }

  .score-value-tip {
    padding-bottom: .3rem;
    text-align: center;
    font-size: .34rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
  }

  .score-comment-box {
    margin: 0 10px 10px;
    background: #D3EBFF;
    height: 1.2rem;
    border-radius: .1562rem;

  }

  .score-comment-head {
    padding: 10px 20px;
  }

  .score-comment-head-right img {
    width: .1875rem;
  }

  .score-comment-text {
    padding: 0 20px;
    font-size: .2rem;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .key-right {
    width: 95%;
  }

  .key-delete, .key-button {
    width: 100%;
    height: 1.9rem;
    background: #fff;
    border-radius: 0.0781rem;
  }

  .key-button {
    font-size: .5rem;
  }

  .key-delete img {
    width: 0.5rem;
  }

  .key-button {
    margin-top: .05078rem;
  }

  .key-left {
    display: flex;
    flex-wrap: wrap;
    /*width: 3.0816rem;*/
  }

  .key-li {
    width: 1.6rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.1rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .key-li-full {
    width: 3.3rem;
    height: 0.9rem;
    background: #fff;
    border-radius: 0.0781rem;
    margin: 0 .1rem .05rem 0;
    font-size: 0.5rem;
    color: #323233;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .score-content {
    padding: 0.48rem 0.3rem;
  }

  .score-content-bottom {
    /*width: 4.1367rem;*/
    background: #F2F3F5;
    border-radius: 0.15625rem;
    height: 4rem;
    padding: 0 0.0859rem;
  }

  .score-value-box {
    background: #fff;
    /*height: 3rem;*/
    border-radius: 0.15625rem;
    box-shadow: 0px 2px 20px 0px rgba(74, 144, 226, 0.1);
  }

  .score-caipan-box {
    height: .66rem;
    border-radius: 0.5rem;
    color: #fff;
    font-weight: 500;
    font-size: .18rem;
    margin: .2rem 0;
    background: #1989FA;
  }

  .score-caipan-value {
    margin: 0 32px 0 22px;
    height: 100%;
  }

  .score-head {
    /*background: url('https://static.dierqudao.com/images/cca/score-bg.png') no-repeat;*/
    background: url('../../../assets/images/score/score-bg.png') no-repeat;
    background-size: 100% 1.6rem;
    height: 1.6rem;
    text-align: center;
    color: #fff;
    font-weight: 500;
  }

  .score-logo {
    position: absolute;
    top: .15rem;
    left: .195rem;
  }

  .score-logo-box {
    padding: 2px;
    background: rgb(255, 255, 255);
    border-radius: 100%;
    height: 0.5rem;
  }

  .score-logo-box img {
    min-width: 0.5rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 100%;
  }

  .score-title {
    font-size: 0.28rem;
    font-weight: 500;
    padding: .2rem 0 0;
    margin: 0 1rem .1rem;
  }

  .score-title-child {
    font-size: .18rem;
    /*padding: 19px 0;*/
  }
}

</style>
<script>

import {
  Cell,
  Field,
  Tag,
  CellGroup,
  Stepper,
  Toast,
  Button,
  Switch,
  NumberKeyboard
} from 'vant';
import validator from "../../../utils/validator";

export default {
  name: 'CommonLogin',
  components: {
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Tag.name]: Tag,
    [Stepper.name]: Stepper,
    [Switch.name]: Switch,
    [NumberKeyboard.name]: NumberKeyboard,
  },
  data: function () {
    return {
      validator,
      isSubmit: false,
      keyShow: false,
      showGradePicker: false,
      numShow: false,
      exame_id: this.$route.query.exame_id,
      message: "",
      userNum: '',
      formData: {
        needLoadingIndicator: true,
        currentIndex: 0,
        exame_id: this.$route.query.exame_id,
        name: '',
        grade: '',
        pic: [],
      },
      list2: [],
      user: {
        index: 1
      },
      exame: {
        extra_data: {}
      },
      warnings: [],
      saveLoading: false,
      scoreSaveLoading: false,


      kaoguan: [], 
      jiandu: [], 

      apply:{

      },
      memberRow:{
        huankao:0
      },
      userIndex:0,

      currentIndex: 0, // 当前进行的分组值
      currentMemberIndex: 0, // 选中的tab值


      scoreValue :0,
      scoreName :0,
      scoreLabel :'',
      scoreVisible:false,
    }
  },
  filters: {},
  mounted() {
    document.title = "评分页";
    this.fetch();
    let that = this;

    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 3000)
  },
  watch: {
    keyShow(val) {
      if (val) {
        window.scrollTo(0, 50000);
      } else {
        window.scrollTo(0, 0);
      }
    }
  },
  destroyed() {
  },
  methods: {
    fetch() {
      let that = this;
      that.$api.get('/api/kaojiexame/scoreFormDetail', {
        exame_id: that.exame_id,
        num: sessionStorage.getItem('qcxjcpnum')
      }, (res) => {

        that.list2 = res.data.list2  
        that.apply = res.data.apply  
        that.kaoguan = res.data.exame.kaoguan  
        that.jiandu = res.data.apply.jiandu  
         
        that.user = res.data.user;
        that.exame = res.data.exame;
        that.userIndex = that.user.index;
        that.scoreCompute();
        that.numShow = false;
      }, (res) => {
        if (res.code == 409) {
          that.numShow = true;
        }
        Toast.fail(res.msg);
      })
    },


    onSubmit() {
      let that = this

      if (!that.userNum) {
        Toast('请输入身份证号')
        return
      }

      sessionStorage.setItem('qcxjcpnum', this.userNum);
      that.fetch();
    },

    onFocus() {
      this.keyShow = true
      // this.readonly = false
    },

    switchChange(val) {
      let value = val ? 1 : 2;
      console.log('switchChange', value)
      localStorage.setItem('_is_local', value);

      // 传递数据给app
      appEvent({
        name: 'postMessage',
        query: {
          value: value
        }
      });
    },

    toCheckLogin() {
      let list = this.list
      if (list.length == 0) {
        Toast.fail('暂无进行中的比赛')
      } else {
        this.show = true
      }
    },

    toScoreCheck(id) {
      rbLink({
        name: 'CommonScoreCheck',
        query: {
          id: id
        }
      });
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },


      scoreCompute(){
        let that = this

        let item  = that.list2[that.currentIndex][that.currentMemberIndex];  
         
          let score_total = 0;
          score_total += parseFloat((item.score_sai>0?item.score_sai:0)*10);
          score_total += parseFloat((item.score_peixun>0?item.score_peixun:0)*10);
          score_total += parseFloat((item.score_gongyi>0?item.score_gongyi:0)*10);


          let score_fanteng =0;
          let score_zhuanti =0;
          let score_tiaoyue =0;
          let score_pingheng =0;
          let score_liliang =0;
          let score_dongzuo =0;

          let score_fanteng_kaoguan =0;
          let score_zhuanti_kaoguan =0;
          let score_tiaoyue_kaoguan =0;
          let score_pingheng_kaoguan =0;
          let score_liliang_kaoguan =0;
          let score_dongzuo_kaoguan =0;

          that.kaoguan.map((kaoguan,index) =>{
//            if(item['score_fanteng'+(index+1)]>0){
              score_fanteng += parseFloat(item['score_fanteng'+(index+1)])*10;
              score_fanteng_kaoguan ++;
//            }
//            if(item['score_zhuanti'+(index+1)]>0){
              score_zhuanti += parseFloat(item['score_zhuanti'+(index+1)])*10;
              score_zhuanti_kaoguan ++;
//            }
//            if(item['score_tiaoyue'+(index+1)]>0){
              score_tiaoyue += parseFloat(item['score_tiaoyue'+(index+1)])*10;
              score_tiaoyue_kaoguan ++;
//            }
//            if(item['score_pingheng'+(index+1)]>0){
  
              score_pingheng += parseFloat(item['score_pingheng'+(index+1)])*10;
              score_pingheng_kaoguan ++;
//            }
//            if(item['score_liliang'+(index+1)]>0){
              score_liliang += parseFloat(item['score_liliang'+(index+1)])*10;
              score_liliang_kaoguan ++;
//            }
//            if(item['score_dongzuo'+(index+1)]>0){
              score_dongzuo += parseFloat(item['score_dongzuo'+(index+1)])*10;
              score_dongzuo_kaoguan ++;
//            }


          });

          item.score_fanteng=score_fanteng = score_fanteng_kaoguan>0?parseFloat(score_fanteng/score_fanteng_kaoguan):0;
          item.score_zhuanti=score_zhuanti = score_zhuanti_kaoguan>0?parseFloat(score_zhuanti/score_zhuanti_kaoguan):0;
          item.score_tiaoyue=score_tiaoyue = score_tiaoyue_kaoguan>0?parseFloat(score_tiaoyue/score_tiaoyue_kaoguan):0;
          item.score_pingheng=score_pingheng = score_pingheng_kaoguan>0?parseFloat(score_pingheng/score_pingheng_kaoguan):0;
          item.score_liliang=score_liliang = score_liliang_kaoguan>0?parseFloat(score_liliang/score_liliang_kaoguan):0;
          item.score_dongzuo=score_dongzuo = score_dongzuo_kaoguan>0?parseFloat(score_dongzuo/score_dongzuo_kaoguan):0;
            console.log('item.score_dongzuo',item.score_dongzuo);
            console.log('item.score_fanteng',item.score_fanteng);
            console.log('item.score_zhuanti',item.score_zhuanti);
            console.log('item.score_tiaoyue',item.score_tiaoyue);
            console.log('item.score_pingheng',item.score_pingheng);
            console.log('item.score_liliang',item.score_liliang);

          score_total +=  score_fanteng+score_zhuanti+score_tiaoyue+score_pingheng+score_liliang+score_dongzuo;
//                  parseFloat((score_fanteng>0?score_fanteng:0)*10)
//                    +parseFloat((score_zhuanti>0?score_zhuanti:0)*10)
//                    +parseFloat((score_tiaoyue>0?score_tiaoyue:0)*10)
//                    +parseFloat((score_pingheng>0?score_pingheng:0)*10)
//                    +parseFloat((score_liliang>0?score_liliang:0)*10)
//                    +parseFloat((score_dongzuo>0?score_dongzuo:0)*10)

          console.log('item.score_liliang1111',item.score_total);

//          score_total = parseFloat(item.score_sai) + parseFloat(item.score_peixun) + parseFloat(item.score_gongyi);// +parseFloat(score_fanteng);
          item.score_total = score_total/10; 

          that.memberRow = item;
      },
      changeMember(index){
        this.currentMemberIndex = index;
        this.scoreCompute();
      },
      changeCurrent(index){
        this.currentMemberIndex = 0;
        this.currentIndex = index;
        this.scoreCompute();
      },


    // 操作分数
    onScoreOperate(score_name,score_label) {
      let that = this 
      that.scoreVisible = true

      // console.log("onScoreOperate", index, that.scoreValue)

      that.scoreValue = that.memberRow[score_name+this.userIndex];
      that.scoreName = score_name;
      that.scoreLabel = score_label;
      console.log('onScoreOperate') 
    },
 
 
 
    // 存储分数
    onScoreSave() {  
      let that = this;
      that.$api.get('/api/kaojiexame/scoreSimpleSave', {
        id: that.memberRow.id,
        score_name: that.scoreName+that.userIndex,
        score_value: that.scoreValue,
      }, (res) => {
        this.scoreVisible = false;
        that.fetch(); 
      }, (res) => { 
        Toast.fail(res.msg);
      })

     },

    // 切换下一支队伍
    onSubjectNext() {
      let that = this
      if(that.currentIndex == that.list2.length-1){
        Toast('已经是最后一组');
        return ;
      }
      that.currentMemberIndex = 0;
      that.currentIndex ++  ;
      that.scoreCompute();
    },

    // 切换指定队伍
    onSubjectCurrent(index) {
      let that = this
      that.currentIndex = index
 
      that.scoreCompute();
    },

    // 切换上一支队伍
    onSubjectPrev() {
      let that = this
      if(that.currentIndex == 0){
        Toast('已经是第一组了');
        return ;
      }
      that.currentMemberIndex = 0;
      that.currentIndex-- ;
      that.scoreCompute();
      
    },


    // 键盘输入
    onKey(value) {
      /**
       * 1. 不能有两个小数点
       * 2. 小数不能为 5
       * 3. 值需要是1-100 以内的值
       */
      let score = this.scoreValue
      // 打分完成 禁止输入
      // if (this.scoreCurrent) return


      console.log(value, score, score.length)

      if (value == 'delete' && score.length > 0) {
        // 删除
        score = score.substring(0, score.length - 1);
        this.scoreValue = score
        return;
      }

      if (value === 'delete') return
      if ((!score || score.indexOf('.') > -1) && value === '.') {
        return
      }
      if (!score && value === 0) return

      if (score.indexOf('.') > -1 && value != 5) {
        score = score.substring(0, score.length - 1);
        this.scoreValue = score
        Toast('小数值只能为5');
        return
      }

      score = score + value

      if (score > 100) {
        Toast('分值不能大于100哦');
        return
      }


      this.scoreValue = score
    },

  }
}
</script>



// WEBPACK FOOTER //
// ExameScoreForm.vue?7be4112b